export default "__VITE_ASSET__CtvQyBN2__"